<template>
  <div>
    <div class="page-actions">
      <span>选择时间：</span>
      <el-date-picker
        v-model="times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-input placeholder="请输入节点ID" v-model="nodeId"></el-input>
      <el-input placeholder="请输入节点名称" v-model="nodeNameLike"></el-input>
      <el-input placeholder="请输入用户ID" v-model="userId"></el-input>
      <span>是否激活：</span>
      <el-switch v-model="activation" @change="serch()"></el-switch>
      <el-button type="primary" @click="serch()" size="small">查询</el-button>
      <el-button type="success" @click="serchAll()" size="small"
        >全部</el-button
      >
    </div>
    <el-table :data="records">
      <el-table-column label="注册时间">
        <template slot-scope="scope">
          <span>{{ scope.row.ctreateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="nodeId" label="节点ID"> </el-table-column>
      <el-table-column prop="foundationNum" label="新人抢购次数">
      </el-table-column>
      <el-table-column prop="nodeName" label="节点名称"> </el-table-column>
      <el-table-column prop="activate" label="是否激活">
        <template slot-scope="scope">
          <span v-if="scope.row.activate">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="激活时间">
        <template slot-scope="scope">
          <span>{{ scope.row.activateTime | moment }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'newpeople',
  data() {
    return {
      times: [],
      activation: false,
      nodeId: '',
      nodeNameLike: '',
      userId: ''
    };
  },
  computed: {
    ...mapState('newpeople', ['totalCount', 'pagination', 'records']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations('newpeople', ['setpage']),
    ...mapActions('newpeople', ['getRecords']),
    handleCurrentChange(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    },
    serch() {
      this.pagination.page = 1;
      this.getRecords({
        startTime: this.startTime,
        endTime: this.endTime,
        ...this.pagination,
        activation: this.activation,
        nodeNameLike: this.nodeNameLike,
        nodeId: this.nodeId,
        userId: this.userId
      });
    },
    serchAll() {
      this.pagination.page = 1;
      this.getRecords({
        ...this.pagination
      });
    }
  }
};
</script>

<style lang="less" scoped>
img {
  max-height: 70px;
}
</style>
